import { Id, isSuccess } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { contactFilterService } from "../shared/api/contactFilterService";

interface Options {
	contactFilterId: Id | null;
	onNotFound?: () => void;
}

export const useContactFilterQuery = ({ contactFilterId, onNotFound }: Options) => {
	return useQuery({
		enabled: contactFilterId != null,
		queryKey: contactFilterService.showKey(String(contactFilterId)),
		queryFn: async () => {
			if (!contactFilterId) return null;
			const response = await contactFilterService.show(contactFilterId);
			if (isSuccess(response)) {
				return response.data.data;
			} else if (response instanceof AxiosError && response.response?.status === 404) {
				onNotFound?.();
			}
			return null;
		},
	});
};
